// Pure: produce a preview copy of `journeys` where, in the journey `journeyId`, the
// touchpoint matching previewTouchpoint.touchpoint_id is replaced by previewTouchpoint
// and moved to `targetIndex` among that journey's ordinal-sorted touchpoints. That
// journey's ordinals are reassigned 1..n in the new order (preview-only — deriveModel
// only needs relative order). Other journeys are returned unchanged (same refs).
// Never mutates the input. Returns `journeys` unchanged if the journey/touchpoint
// isn't found.
// When `insert` is true and the preview id isn't already in the journey, the preview is
// SPLICED IN at targetIndex (live preview of a not-yet-saved "create"). With insert false
// (edit/move) an unknown id returns `journeys` unchanged, as before.
export function applyPreview(journeys, journeyId, previewTouchpoint, targetIndex, insert = false) {
  if (!previewTouchpoint) return journeys;
  const journey = journeys.find((j) => j.journey_id === journeyId);
  if (!journey) return journeys;
  const sorted = [...journey.touchpoints].sort((a, b) => a.ordinal - b.ordinal);
  const from = sorted.findIndex((t) => t.touchpoint_id === previewTouchpoint.touchpoint_id);
  if (from < 0 && !insert) return journeys;

  const without = from < 0 ? sorted : sorted.filter((t) => t.touchpoint_id !== previewTouchpoint.touchpoint_id);
  const clampedIndex = Math.max(0, Math.min(without.length, targetIndex));
  const reordered = [...without.slice(0, clampedIndex), previewTouchpoint, ...without.slice(clampedIndex)]
    .map((t, i) => ({ ...t, ordinal: i + 1 }));

  return journeys.map((j) => (j.journey_id === journeyId ? { ...j, touchpoints: reordered } : j));
}
